import React, { useState } from 'react';
import { User, Lock, LogIn, RotateCcw } from 'lucide-react';
import AuthFormContainer from './AuthFormContainer';
import InputField from './InputField';

export default function LoginPage({ onLogin, setPage }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username && password) {
      onLogin({ username, password }, setError, setLoading);
    } else {
      setError('Please enter both username and password.');
    }
  };

  return (
    <AuthFormContainer
      title="Welcome Back"
      footer={
        <p>
          Don&apos;t have an account?{' '}
          <button
            onClick={() => setPage('register')}
            className="font-medium text-teal-600 hover:text-teal-500"
          >
            Register here
          </button>
        </p>
      }
    >
      <form onSubmit={handleSubmit} className="space-y-6">
        {error && (
          <p className="text-sm text-red-600 text-center bg-red-100 p-3 rounded-lg">
            {error}
          </p>
        )}
        <InputField
          icon={<User />}
          name="username"
          type="text"
          placeholder="Enter Mobile Number"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <InputField
          icon={<Lock />}
          name="password"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />



        {/* Sign In Button */}
        <div>
          <button
            type="submit"
            disabled={loading}
            className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500 transition duration-300 shadow-sm hover:shadow-lg disabled:bg-teal-400 disabled:cursor-not-allowed"
          >
            <span className="absolute left-0 inset-y-0 flex items-center pl-3">
              <LogIn className="h-5 w-5 text-teal-500 group-hover:text-teal-400" />
            </span>
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </div>
        {/* Forgot Password link */}
        <div className="text-right">
          <button
            type="button"
            onClick={() => setPage({ name: 'forgot' })}
            className="text-sm text-teal-600 hover:underline flex items-center gap-1"
          >
            <RotateCcw className="h-4 w-4" />
            Forgot Password?
          </button>
        </div>
      </form>
    </AuthFormContainer>
  );
}
